import { FC } from "react";
import ModuleSkeleton from "shared/components/ModuleSkeleton";
import { SkeletonCard } from "./styled";

const OneBigCardSkeleton: FC = () => {
  return (
    <ModuleSkeleton>
      <SkeletonCard />
    </ModuleSkeleton>
  );
};

export default OneBigCardSkeleton;
